var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.073 12.3949C11.5847 12.3949 12.805 11.1746 12.805 9.66287V4.19882C12.805 2.6871 11.5847 1.4668 10.073 1.4668C8.56125 1.4668 7.34094 2.6871 7.34094 4.19882V9.66287C7.34094 11.1746 8.56125 12.3949 10.073 12.3949ZM9.16229 4.19882C9.16229 3.69795 9.5721 3.28815 10.073 3.28815C10.5738 3.28815 10.9836 3.69795 10.9836 4.19882V9.66287C10.9836 10.1637 10.5738 10.5735 10.073 10.5735C9.5721 10.5735 9.16229 10.1637 9.16229 9.66287V4.19882ZM14.6263 9.66287C14.6263 12.1763 12.5864 14.2162 10.073 14.2162C7.5595 14.2162 5.51959 12.1763 5.51959 9.66287H3.69824C3.69824 12.8776 6.0751 15.5185 9.16229 15.9647V18.7696H10.9836V15.9647C14.0708 15.5185 16.4477 12.8776 16.4477 9.66287H14.6263Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicNone);
export default __webpack_public_path__ + "static/media/mic_none.3915a769e7d53ed0f164de817723bbc1.svg";
export { ForwardRef as ReactComponent };